export default "/build/images/mc.png?0d850a8fe33ea1eeef618772a0844fd6";